import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import Star1 from '../../Layers/star-1.png.js';
import Star2 from '../../Layers/star-2.png.js';
import Star3 from '../../Layers/star-3.png.js';
import { DEFAULT_MEDIA_GRADIENT_2, DEFAULT_MEDIA_GRADIENT_1, DEFAULT_MEDIA_BOX_SHADOW, DEFAULT_MEDIA_BG, DEFAULT_BOX_SHADOW, DEFAULT_BOX_BORDER, DEFAULT_BOX_BG } from './constants/layers.js';
import styles from './index.module.scss.js';

const CategorySkin = ({
  id,
  href,
  title,
  subtitle,
  size = "MD",
  type,
  customizedLayers,
  imageLayers,
  additionalInfo,
  index,
  className,
  style,
  ...props
}) => {
  const [animatedHeight, setAnimatedHeight] = useState(0);
  const titleRef = useRef(null);
  const getTitle = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: styles.title,
      dangerouslySetInnerHTML: {
        __html: title || ""
      }
    }
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: styles["title--hidden"],
      dangerouslySetInnerHTML: {
        __html: title || ""
      },
      ref: titleRef
    }
  ));
  const getSubtitle = () => /* @__PURE__ */ React.createElement("div", { className: styles.subtitle }, subtitle);
  useEffect(() => {
    if (titleRef.current) {
      setAnimatedHeight(`${titleRef?.current?.offsetHeight / 2}px`);
    }
  }, [titleRef]);
  return /* @__PURE__ */ React.createElement(
    Link,
    {
      className: `${cx(styles.box, {
        [styles[type || ""]]: !!type,
        [styles[size || ""]]: !!size,
        [styles.CUSTOM_GRADIENT_LAYERS]: customizedLayers
      })} ${className}`,
      to: href,
      key: index,
      style: {
        ...style,
        "--container-background": customizedLayers?.containerBackground || DEFAULT_BOX_BG,
        "--container-border-color": customizedLayers?.containerBorderColor || DEFAULT_BOX_BORDER,
        "--container-shadow": customizedLayers?.containerBoxShadow || DEFAULT_BOX_SHADOW,
        "--media-background": customizedLayers?.mediaBackground || DEFAULT_MEDIA_BG,
        "--media-shadow": customizedLayers?.mediaBoxShadow || DEFAULT_MEDIA_BOX_SHADOW,
        "--media-gradient-1": customizedLayers?.mediaGradientLayer1 || DEFAULT_MEDIA_GRADIENT_1,
        "--media-gradient-2": customizedLayers?.mediaGradientLayer2 || DEFAULT_MEDIA_GRADIENT_2,
        "--media-image": customizedLayers?.mediaImage,
        "--title-hover-height": animatedHeight
      },
      ...props
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.box__inner }, /* @__PURE__ */ React.createElement("div", { className: styles.media }, /* @__PURE__ */ React.createElement("div", { className: styles.media__wrapper }, /* @__PURE__ */ React.createElement("div", { className: styles.media__img }, /* @__PURE__ */ React.createElement(
      "img",
      {
        src: customizedLayers ? customizedLayers.mediaImage : imageLayers?.mediaImage,
        alt: title
      }
    ), /* @__PURE__ */ React.createElement("div", { className: styles.media__layer_0 }), /* @__PURE__ */ React.createElement("div", { className: styles.media__layer_1 }), /* @__PURE__ */ React.createElement("div", { className: styles.media__layer_2 })), /* @__PURE__ */ React.createElement("img", { src: Star1, className: styles.star_1, alt: "card star1" }), /* @__PURE__ */ React.createElement("img", { src: Star2, className: styles.star_2, alt: "card star2" }), /* @__PURE__ */ React.createElement("img", { src: Star3, className: styles.star_3, alt: "card star3" }), getTitle())), getSubtitle(), imageLayers?.backgroundImage && /* @__PURE__ */ React.createElement(
      "img",
      {
        className: styles.background,
        src: imageLayers.backgroundImage,
        alt: "background"
      }
    ))
  );
};

export { CategorySkin as default };
//# sourceMappingURL=index.js.map
